import Vue from 'vue';

export default Vue.component('linkTarget', {
    props: {
        name: String
    },
    data: function() {
            return { 
                lcName: this.$props.name.toLowerCase().replace(/ /g, "")
            }
        }
});
